// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"fr-z","outfitFeedbackSection":"gr-z"};